// extracted by mini-css-extract-plugin
export var fileUpload = "_f7-1";
export var modalButton = "_f7-0";